import { Field, Select } from "@zendeskgarden/react-forms";
import type { SelectProps } from "./selectType";

export default function SelectDefault({
  label,
  options,
  value,
  onChange,
  disabled,
  initialOption
}: SelectProps) {

  return (
    <Field>
      {label && <Field.Label>{label}</Field.Label>}
      <Select value={value} onChange={(e) => onChange?.(e.target.value)} disabled={disabled}>
        <option value="">
          {initialOption}
        </option>
        {options.map((option) => {
          const opt =
            typeof option === "string"
              ? { label: option, value: option }
              : option;

          return (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          );
        })}
      </Select>
    </Field>
  );
}
